import * as z from "zod"

export const emailSchema = z
   .string({ required_error: "Email is required" })
   .trim()
   .min(1, "Email is required")
   .email("Please enter a valid email address")
   .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format")
   .transform((val) => val.toLowerCase())

export const loginFormSchema = z
   .object({
      email: emailSchema,
      password: z.string().optional(),
      user_group_id: z.string().optional().nullable(),
      loginMethod: z.enum(["credentials", "email"]),
   })
   .refine(
      (data) => {
         if (data.loginMethod === "credentials") {
            return data.password && data.password.length > 0
         }
         return true
      },
      {
         message: "Password is required for credentials login",
         path: ["password"],
      },
   )

export type LoginFormInputs = z.infer<typeof loginFormSchema>
